import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=db9c2a86&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=ts&"
export * from "./Chat.vue?vue&type=script&lang=ts&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=db9c2a86&prod&lang=scss&scoped=true&"
import style1 from "./Chat.vue?vue&type=style&index=1&id=db9c2a86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9c2a86",
  null
  
)

export default component.exports